import { render, staticRenderFns } from "./bf-trustpilot-reviews.vue?vue&type=template&id=1728f0d1&"
import script from "./bf-trustpilot-reviews.vue?vue&type=script&lang=js&"
export * from "./bf-trustpilot-reviews.vue?vue&type=script&lang=js&"
import style0 from "./bf-trustpilot-reviews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports